import styled from 'styled-components';
import {
    Alert,
    Adornment,
    AdornedInput,
    FormHelp,
    token,
} from '@zillow/constellation';

export const StyledAdornedInput = styled(AdornedInput)`
    margin-bottom: 8px;
    width: 100%;
    
    /* 768 */
    @media (min-width: ${token('breakpoints.lg') - 1}px) {
        width: 75%;
    }
`;

export const StyledAdornment = styled(Adornment)`
    padding-right: 4px;
`;

export const StyledFormHelp = styled(FormHelp)`
    font-weight: 600;
`;

export const StyledAlert = styled(Alert)`
    font-size: 14px;
`;
